import { Heading, Typography } from "@hawkins/components";
import { IconCircleCheckmarkFill } from "@hawkins/assets";

import { Maybe } from "graphql/jsutils/Maybe";
import { M1Button } from "../../molecules/M1Button/M1Button";

import styles from "./SuccessfulFormSubmission.module.scss";

interface IProps {
  title?: Maybe<string> | undefined;
  description?: Maybe<string> | undefined;
  buttonLabel?: Maybe<string> | undefined;
  onButtonClick: () => void;
}

export const SuccessfulFormSubmission = ({
  title,
  description,
  buttonLabel,
  onButtonClick,
}: IProps) => {
  return (
    <div className={styles.successfulFormSubmission}>
      <div className={styles.successfulFormSubmissionContent}>
        <IconCircleCheckmarkFill size="jumbo" />

        <Heading level={4}>{title}</Heading>
        <Typography variant="paragraph-medium">{description}</Typography>
      </div>

      <M1Button variant="primary" onClick={onButtonClick}>
        {buttonLabel}
      </M1Button>
    </div>
  );
};
